import * as React from 'react';
import { Switch } from 'kui';
import { ISectionTogglerProps } from './types';
import './_SectionToggler.scss';

export const SectionToggler = ({
    checked,
    isDisabled,
    isDisallowed,
    onLoad,
    onChange,
    onClickDisabled,
    onClickDisallow,
}: ISectionTogglerProps) => {
    const className = 'section-toggler';
    const classDisallow = className + '__disallow';
    React.useEffect(() => {
        if (onLoad)
            onLoad();
    }, []);
    return (
        <div className={className}>
            <Switch
                checked={checked}
                disabled={isDisabled}
                onChange={onChange}
            />
            {(isDisallowed && onClickDisallow || isDisabled && onClickDisabled) &&
                <div
                    className={classDisallow}
                    onClick={onClickDisabled ? onClickDisabled : onClickDisallow}
                />
            }
        </div>
    );
};
